export const mobileRightMenuVariant = {
    initial: {
        opacity: 0,
        right: -300,
    },
    animate: {
        opacity: 1,
        right: 0,
        transition: { duration: 4 }
    },
    exit: {
        opacity: 0,
        transition: { duration: 4 }
    }
}